"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeartCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HeartCircleLinear = function HeartCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.161 21.226c-2.824-2.968-7.424-2.968-10.249 0-2.892 3.038-2.15 7.3-.118 10.477 1.482 2.321 4.136 5.1 6.36 7.257a106.98 106.98 0 004.05 3.723l.065.056.02.018c.204.176.46.256.711.241a.999.999 0 00.708-.24l.023-.019.065-.056c.057-.05.14-.121.246-.215a106.98 106.98 0 003.804-3.508c2.224-2.156 4.878-4.936 6.36-7.257 2.032-3.178 2.774-7.44-.118-10.477-2.825-2.968-7.425-2.968-10.25 0l-.838.883-.839-.884zm1.517 21.5l.03.033-.03-.034zm-.077-2.54l-.601.536a104.69 104.69 0 01-3.454-3.197c-2.222-2.155-4.723-4.794-6.067-6.899-1.804-2.821-2.087-5.953-.118-8.021 2.036-2.14 5.315-2.14 7.352 0l1.537 1.618a1 1 0 00.743.312h.041a1 1 0 00.716-.312l1.538-1.62c2.036-2.138 5.315-2.138 7.351.002 1.97 2.068 1.686 5.2-.118 8.022-1.345 2.105-3.845 4.743-6.067 6.897a104.69 104.69 0 01-2.853 2.662z",
    fill: "url(#HeartCircleLinear_svg__HeartCircleLinear_svg__paint0_linear_17373_95648)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30zm-2 0c0 15.464-12.536 28-28 28S2 45.464 2 30 14.536 2 30 2s28 12.536 28 28z",
    fill: "url(#HeartCircleLinear_svg__HeartCircleLinear_svg__paint1_linear_17373_95648)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "HeartCircleLinear_svg__HeartCircleLinear_svg__paint0_linear_17373_95648",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HeartCircleLinear_svg__HeartCircleLinear_svg__paint1_linear_17373_95648",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.HeartCircleLinear = HeartCircleLinear;
var _default = HeartCircleLinear;
exports.default = _default;